import CloseIcon from "@mui/icons-material/Close";
import DashboardIcon from "../../assets/images/icons/DashboardIcon.svg"
import EditRestrictedIcon from "../../assets/images/icons/EditRestrictedIcon.svg"

// Add interface for props
interface SellRequestEditValidationPopupProps {
  redirectToDashboard: () => void;
  onCancel: () => void;
  type: string; // 'PENDING_REQUESTS' | 'ALREADY_SOLD' | 'REQUEST_CANCELLED'
}

export default function SellRequestEditValidationPopup({
  redirectToDashboard,
  onCancel,
  type
}: SellRequestEditValidationPopupProps) {

  return (
    <>
      <div
        className="modal modal__wd modal__wd--submitSellReq fade show barrel-assignment-modal signup-success-modal"
        id="rejectUserModal"
        tabIndex={-1}
        aria-labelledby="rejectUserModalLabel"
        aria-hidden="false"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header flex-row align-items-center justify-content-between">
              <h1 className="modal-title" id="rejectUserModalLabel">
                Sell Request Edit
              </h1>
              <button
                type="button"
                className="pt-1 p-0 bg-transparent border-0 text-light"
                onClick={onCancel}
              >
                <CloseIcon />
              </button>
            </div>
            <div className="modal-body">
              <div className="text-center">
                <span className="warning-icon-wrapper" style={{ backgroundColor: "#F8D7DA" }}>
                  <div className="rounded-pill success-smiley">
                    <img src={EditRestrictedIcon} alt="Edit Restricted" />
                  </div>
                </span>
              </div>
              <h2 className="modal-body__title">
                Request Edit Restricted
              </h2>

              <p className="modal-text">
                {type === 'PENDING_REQUESTS' 
                  ? 'This request has pending actions that require your attention. Please complete them before editing the request.'
                  : type === 'ALREADY_SOLD' 
                  ? 'This request cannot be edited because all associated container have already been sold.' 
                  : 'This request has already been cancelled and cannot be edited.'}
              </p>
            </div>
            <div className="modal-footer">
              <div className="d-flex justify-content-center gap-2 flex-wrap w-100">
                <button
                  type="button"
                  className="btn secondary-btn px-5"
                  onClick={onCancel}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn primary-btn d-flex gap-2 justify-content-center align-items-center"
                  onClick={redirectToDashboard} 
                >
                  {type === 'PENDING_REQUESTS' ? (
                    <>
                      <img src={DashboardIcon} alt="Dashboard" />
                      Dashboard
                    </>
                  ) : (
                    'Ok'
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}
